import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { ErrorBoundary } from '@parkify/ui/error-boundary'
import App from './App'
import '@parkify/brand-tokens/tokens.css'
import './styles.css'

// Google sign-in for Parkify staff and an operator's own team members only. An
// enforcement partner never touches this. The
// provider throws at hook-init without a clientId, so an unconfigured build gets
// a placeholder and the app hides the sign-in button (see GOOGLE_CONFIGURED in
// App.tsx). A partner's `?k=` link keeps working either way.
const GOOGLE_CLIENT_ID = import.meta.env.VITE_AUTH_GOOGLE_CLIENT_ID as string | undefined
// Staging build only: makes it impossible to mistake test data for a real lot.
const STAGING = import.meta.env.VITE_STAGING === '1'

// Root error boundary (parity with parkify-demo#91): a render error anywhere
// below shows a fallback card with a reload action instead of unmounting the
// whole tree and leaving a blank page.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary label="patrol">
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID || 'unconfigured.apps.googleusercontent.com'}>
        {STAGING && <div role="status" style={{ position: 'relative', zIndex: 1000, background: '#2d1140', color: '#fff', textAlign: 'center', padding: '6px 12px', fontSize: 12, fontWeight: 800, letterSpacing: 1 }}>STAGING · TEST DATA</div>}
        <App />
      </GoogleOAuthProvider>
    </ErrorBoundary>
  </StrictMode>,
)
